const defaultComment = '';

export default defaultComment;
